<template>
  <div class="state-wrap">
    <div class="row">
      <div class="main_timeline">
        <div class="day-filter">
          <div
            class="title-filter"
            @click="show = !show"
            v-click-outside="closeModelList"
          >
            <img
              class="title-down"
              src="../../images/dashboard/down-blue.png"
              alt="#"
            />
            <span class="drop-down-menu">{{ title[step] }}</span>
          </div>
          <transition>
            <FilterDays @title="setTitle" :steps="steps" v-if="show"></FilterDays>
          </transition>
        </div>
        <div class="input-wrap title_check sub-filter">
          <label class="radio-span">
            <input type="radio" name="kit_type" value="1" v-model="kitType" /> Amazon
          </label>
          <label class="radio-span">
            <input type="radio" name="kit_type" value="2" v-model="kitType" /> Woo
          </label>
          <label class="radio-span">
            <input type="radio" name="kit_type" value="3" v-model="kitType" /> All
          </label>
        </div>
        <div class="book-img">
          <span
            class="download-link inventory"
            title="Inventory"
            target="_blank"
            @click="inventoryShow"
          >
            <span class="radio-span download">
              <img src="../../images/dashboard/inventory.png" alt="#" />
            </span>
            <p>Inventory</p>
          </span>
        </div>
       
      </div>
      <div class="refresh-icon">
        
        <div class="input-wrap title_radio">
          <label
            name="pay_types"
            class="pay_types"
            :style="{ color: payment_type == 'paid' ? '#005eb8' : '#b3b3b3' }"
            v-on:click="payment_type_change('paid')"
            >Paid
          </label>
          <label
            name="pay_types"
            class="pay_types"
            :style="{ color: payment_type == 'free' ? '#005eb8' : '#b3b3b3' }"
            v-on:click="payment_type_change('free')"
            >Promo
          </label>
          <label
            name="pay_types"
            class="pay_types"
            :style="{ color: payment_type === 'both' ? '#005eb8' : '#b3b3b3' }"
            v-on:click="payment_type_change('both')"
            >All</label>
            
        </div>
        <span class="download-link" target="_blank" @click="refreshTestKits"
          ><span class="refresh-link">
            <img
              v-if="!loading"
              src="../../images/dashboard/refresh.png"
              alt="Refresh"
              class="refresh-link-img"
            />
            <img
              v-else
              class="loading-gif"
              src="../../images/dashboard/loading-gif.svg"
              alt="Refresh"
            />
          </span>
        </span>
      </div>
    </div>
    <Amazontimeline v-if="kitType == '1'" @switchOrder="switchOrder"></Amazontimeline>
    <LiveOrderTimeline  v-else @switchOrder="switchOrder" ></LiveOrderTimeline>
    <div class="main-div-durtion">
      <!-- <div class="duration"> -->
        <AmazonDurationTimeline v-if="kitType == '1'" @showoutlinerkits="showoutlinerkits"></AmazonDurationTimeline>
        <DurationTimeline v-else  @showoutlinerkits="showoutlinerkits"></DurationTimeline>
      <!-- </div> -->
      <!-- <div class="state-title" id="myElement"> -->
        <!-- {{ report.total }} <span>Total Test Kits</span>  -->
        <!-- <span
          class="download-link"
          title="Amazon FBA Inventory"
          target="_blank"
          @click="fbaInventoryShow"
        >
          <span class="download">
            <img src="../../images/dashboard/icons8-amazon-50.png" alt="#" />
          </span>
        </span> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import DurationTimeline from "./timeline/DurationTimeline";
import LiveOrderTimeline from "./timeline/LiveOrderTimeline";
import Amazontimeline from "./timeline/Amazontimeline";
import AmazonDurationTimeline from "./timeline/AmazonDurationTimeline";
import FilterDays from "./timeline/FilterDays.vue";
export default {
  name: "State",
  props: ["steps"],
  data() {
    return {
      report: {
        activated: 0,
        analysis_completed: 0,
        lab_received: 0,
        lab_awaiting: 0,
        on_hold: 0,
        shipped: 0,
        total: 0,
      },
      kitType :3,
      loading: false,
      title: {
        30: "30 Days",
        60: "60 Days",
        90: "90 Days",
        1: "Q1",
        2: "Q2",
        3: "Q3",
        4: "Q4",
        5: "YTD",
        0: "All"
      },
      show: false,
      step: 30,
      payment_type: null
    };
  },
  components: {
    DurationTimeline,
    LiveOrderTimeline,
    FilterDays,
    Amazontimeline,
    AmazonDurationTimeline
  },
  computed: {
    ...mapGetters(["adminReport", "getPaymentFilter", "getAnalyticsFilter","getOverDueStatus"])
  },
  watch: {
    kitType(obj){
      this.setkitType(obj);
      this.changeDashboardValues();
      this.overDues();
      if(this.$store.getters.getOverDueStatus) {
          this.setComponentNum(0);
          this.setOverDueStatus(null);
          this.sendSearchReq();
          this.$emit("outlinerkits", {
            steps: 0,
            value: null,
            outlinerfilter: false,
          });
      } else 
      if (this.$store.getters.getComponentNum == 0) {
        this.sendSearchReq();
      } else if (this.$store.getters.getComponentNum == 4) {
        this.sendSearchReqPending();
      }
    },
    adminReport(obj) {
      for (var k in obj) {
        if (this.report.hasOwnProperty(k)) {
          this.report[k] = Number(obj[k]);
        }
      }
    },
    getPaymentFilter(val) {
      this.payment_type = val;
    }
  },
  methods: {
    ...mapActions([
      "RefreshTestkits",
      "testKitAvg",
      "setPaymentFilter",
      "changeDashboardValues",
      "overDues",
      "sendSearchReq",
      "sendSearchReqPending",
      "getWooOrders",
      "setAdminPginationPage",
      "sendSearchReqAnalytics",
      "getAnalyticsInfoList",
      "resetState",
      "setkitType",
      "setAmazonIdel",
      "setSalesData",
      "setComponentNum",
      "setOverDueStatus"
    ]),
    inventoryShow(){
      this.setSalesData();
      this.setAmazonIdel();
      this.$emit("inventoryShow", true);
    },
    fbaInventoryShow(){
      this.setSalesData();
      this.$emit("fbaInventoryShow", true);
    },
    setTitle(obj) {
      this.testKitAvg(obj.value).then(res => {
        this.show = obj.show;
        this.step = obj.value;
      });
      this.sendSearchReq();
      this.$emit("outlinerkits", {
        steps: 0,
        value: null,
        outlinerfilter: false,
      });
    },
    getLabel(value) {
      return this.title[value] || "0";
    },
    closeModelList() {
      this.show = false;
    },
    mouseOver(model) {
      let node = document.getElementsByClassName(model)[0];
      node.style.opacity = "1";
    },
    mouseLeave(model) {
      let className = `${model} opacity`;
      let node = document.getElementsByClassName(className)[0];
      node.style.opacity = "0";
    },
    showoutlinerkits(val) {
      this.$emit("outlinerkits", {
        steps: val.steps,
        value: val.value,
        outlinerfilter: true,
        kitfilter: false
      });
    },
    switchOrder(val) {
      this.$emit("switchOrder", {
        steps: val.steps,
        value: val.value,
        switchOrder: "switchOrder"
      });
    },
    async refreshTestKits() {
      this.loading = true;
      try {
          await this.RefreshTestkits();
      } catch (error) {
          console.error("Error refreshing test kits", error);
      } finally {
          this.loading = false;
      }
    },
    async payment_type_change(val) {
      if (this.$store.getters.getComponentNum != 4) {
        this.resetState();
      }  
      if (val) {
        await this.setPaymentFilter(val);
        this.changeDashboardValues();
        this.testKitAvg();
        this.overDues();
      }
      if (this.$store.getters.getComponentNum == 4) {
        this.sendSearchReqPending();
      } else if (this.$store.getters.getComponentNum == 11) {
        this.getWooOrders();
      } else if(this.$store.getters.getComponentNum == 3) { 
        this.sendSearchReqAnalytics();
        if(this.$store.getters.getShowAnaltics) { 
          this.setAdminPginationPage(null).then(() => {
            const data = this.$store.getters.getAnalyticsFilter;
            this.getAnalyticsInfoList(data);
          });
        }
      } else {
        this.sendSearchReq();
      }
    }
  },
  mounted() {
    this.payment_type = this.$store.getters.getPaymentFilter;
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";

.progress {
  font-family: TTNormsMedium, sans-serif;
  background-color: $white;
  width: 100%;
  border-radius: 27px;
  border: 1px solid #dde1e6;
}
.skill {
  background-color: #dde1e6;
  color: $black;
  padding: 1%;
  text-align: left;
  border-radius: 27px;
  border-radius: 15px;
  width: 60%;
}
.skill span {
  font-size: 14px;
  font-family: TTNormsRegular, sans-serif;
}
.row {
  display: flex;
  align-items: center;
  margin: 0 0 10px 0;
}
.row:last-child {
  margin: 0;
}
.state-wrap {
  background-color: #fff;
  padding: 12px 12px;
  margin-top: 20px;
  margin-bottom: 15px;
  border-radius: 10px;
}
.state-title {
  color: rgb(11, 11, 11);
  width: 30%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  display: block ruby;
  top: 51px;
  position: relative;
  right: 10px;
}
/*.state-title.opacity{*/
/*opacity: 0;*/
/*transition: opacity .5s linear;*/
/*}*/
.state-title span {
  padding: 0 0px 0 4px;
  display: inline-block;
}
.state-title-bottom {
  color: #d7d7d7;
  width: 20%;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-family: TTNormsMedium, sans-serif;
}
.refresh-link {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.refresh-link-img {
  height: 24px;
}

.refresh-icon {
  color: rgb(11, 11, 11);
  width: 50%;
  text-align: right;
  font-family: TTNormsMedium, sans-serif;
  display: flex;
}

.refresh-icon span {
  font-size: 0.9rem;
  padding: 0 0px 0 4px;
  display: inline-block;
  font-family: TTNormsRegular, sans-serif;
  top: 2px;
  position: relative;
  right: 4px;
}

.loading-gif {
  width: 26px;
  height: 23.3833px;
}
.day-filter {
  display: flex;
  align-items: center;
  margin: 5px 10px 0px 5px;
}
.title-filter {
  color: #005eb8;
  font-size: 14px;
  font-weight: 500;
  font-family: TTNormsMedium, sans-serif;
  max-width: 125px;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #e7ecef;
  border-radius: 5px;
  padding: 5px;
  margin-left: 10px;
  min-width: 90px;
}
.title-filter .filter-label {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
}
.drop-down-menu {
  margin: 0px 0px 0px 5px !important;
  font-weight: 500;
}
.title-down {
  height: 16px;
  cursor: pointer;
  vertical-align: top;
  font-weight: 500;
}
.title_radio {
  color: #005eb8;
  font-size: 15px;
  font-weight: 500;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  justify-content: space-between;
  margin: 10px 0 0 0;
  cursor: pointer;
  text-align: right;
}

.title_check {
  margin-top: 10px;
  margin-right: 20px;
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  justify-content: space-between;
  cursor: pointer;
}
.pay_types {
  padding-right: 10px;
}
.main_timeline {
  width:60%;
  display: inline-flex;
}
.download {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.download img {
  max-width: 25px;
  height: auto;
  cursor: pointer;
}
.main-div-durtion{
  display: inline;
}
.book-img{
  margin-top: 5px;
  width: 200px;
  justify-content: center;
  display: inline-flex;
}
.inventory {
  display: inline-flex;
  justify-content: start;
  align-items: center;
  width: 100%;
}
.inventory p {
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
}
</style>
